// const isFound = (state) => state.school_dt.res
const getSchoolInfo = (state) => {
  return {
    scod: state.school_dt.scod,
    schENG: state.school_dt.schENG,
    schKH: state.school_dt.schKH,
    proENG: state.school_dt.proENG,
    proKH: state.school_dt.proKH,
    disENG: state.school_dt.disENG,
    disKH: state.school_dt.disKH,
    comENG: state.school_dt.comENG,
    comKH: state.school_dt.comKH,
    fid: state.school_dt.fid,
    type_code: state.school_dt.type_code,
    principal_name_kh: state.school_dt.principal_name_kh,
    pho_num: state.school_dt.pho_num
  }
}
const getGrade = (state) => {
  return {
    g1: state.school_dt.g1,
    g2: state.school_dt.g2,
    g3: state.school_dt.g3,
    g4: state.school_dt.g4,
    g5: state.school_dt.g5,
    g6: state.school_dt.g6
  }
}
const getScore = (state) => {
  return {
    sco_g1: state.school_dt.sco_g1,
    sco_g2: state.school_dt.sco_g2,
    sco_g3: state.school_dt.sco_g3,
    sco_g4: state.school_dt.sco_g4,
    sco_g5: state.school_dt.sco_g5,
    sco_g6: state.school_dt.sco_g6
  }
}
export {
  // isFound,
  getSchoolInfo,
  getGrade,
  getScore
}
